import AccountHistoryEntry from '@/models/AccountHistoryEntry';
import { getRequest } from '@/api';
import { ACCOUNT_HISTORY_MUTATIONS } from '@/store/mutation-types';
export const state = () => {
  return {
    accountHistoryEntry: new AccountHistoryEntry(),
    cache: {},
    accountHistoryPending: false,
    accountHistoryError: null,
  };
};

export const actions = {
  fetch({ commit, state }, { year, month }) {
    const cached = state.cache[`${year}${month}`];
    if (cached) {
      commit(ACCOUNT_HISTORY_MUTATIONS.SUCCESS, cached);
    } else {
      getRequest(
        `/users/history/${year}/${month}`,
        ACCOUNT_HISTORY_MUTATIONS,
        commit
      );
    }
  },
};

export const mutations = {
  [ACCOUNT_HISTORY_MUTATIONS.SUCCESS]: (state, history) => {
    state.accountHistoryEntry = new AccountHistoryEntry(history);
    state.cache[`${history.year}${history.month}`] = state.accountHistoryEntry;
  },
  [ACCOUNT_HISTORY_MUTATIONS.PENDING]: (state, pending) =>
    (state.accountHistoryPending = pending),
  [ACCOUNT_HISTORY_MUTATIONS.FAILURE]: (state, error) =>
    (state.accountHistoryError = error),
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
